<template>
  <div class="powerDevice" style="height: 100%;color: #FAFAFA;">
    <label style="padding: 20px 0 10px 30px;color: #01effd;" v-if="label">
      <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
      精密配电柜</label>

    <!--电表-->
    <el-row v-if="demDeviceList.length>0" :style="{height: '100%'}">

      <!--      <el-carousel :arrow="meterData.deviceInfoList.length > 1 ? 'always' : 'never'" :interval="50000"-->
      <!--                   indicator-position="none" v-else>-->
      <!--        <el-carousel-item :key="deviceInfos.id" v-for="deviceInfos in meterData.deviceInfoList">-->

      <el-carousel :interval="10000" indicator-position="none" :autoplay="true" style="height: 80%;z-index: 0"
                   @change="getDemData">
        <el-carousel-item :key="item.id" v-for="item in demDeviceList">
          <el-row>
            <el-row class="text-center">
              <label :class="label ?'pointer' : ''"
                  @touchstart="skipOverview(item)"   @click="skipOverview(item)"
                     style="line-height: 3vh;">{{ item.spaceName }} -
                {{ item.name }}</label>
            </el-row>

            <span
              v-if="meterData != null && meterData.deviceInfoList[0] != null && meterData.deviceInfoList[0].deviceMeasuringPointHistoryList.length> 0">
                  <el-row style="margin-top: 10px;">
                    <span :key="history.id" v-for="history in meterData.deviceInfoList[0].deviceMeasuringPointHistoryList">
                      <el-col :span="9" style="margin:2% 0 0 5%">
                        <div style="width: 40%;display: inline-block;text-align: right">
                          <img src="../../assets/images/index/activePower.png" alt="" style="width: 100%;">
                        </div>
                        <div class="point" style="text-align:center;float: right;width: 60%;">
                          <div class="font-weight-bold" style="color: #01EFFD;">{{ history.pointValueName }}</div>
                          <div class="text-blueGrey">{{ history.pointName }}</div>
                        </div>
                      </el-col>
                      <el-col :span="9" style="margin:2% 0 0 5%" v-if="history.pointCode === 'sq'">
                        <div style="width: 40%;display: inline-block;text-align: right">
                          <img src="../../assets/images/index/reactivePower.png" alt="" style="width: 100%;">
                        </div>
                        <div class="point" style="text-align:center;float: right;width: 60%;">
                          <div class="font-weight-bold" style="color: #01EFFD;">{{ history.pointValueName }}</div>
                          <div class="text-blueGrey">{{ history.pointName }}</div>
                        </div>
                      </el-col>
                      <el-col :span="9" style="margin:2% 0 0 5%" v-if="history.pointCode === 'sp'">
                    <div style="width: 40%;display: inline-block;text-align: right">
                      <img src="../../assets/images/index/power2.png" alt="" style="width: 100%;">
                    </div>
                    <div class="point" style="text-align:center;float: right;width: 60%;">
                      <div class="font-weight-bold" style="color: #01EFFD;">{{ history.pointValueName }}</div>
                      <div class="text-blueGrey">{{ history.pointName }}</div>
                    </div>
                  </el-col>
                    </span>
                </el-row>
                </span>
            <div v-else>
              <no-data></no-data>
            </div>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <div v-else style="height: 50%;padding-top: 5%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import {getDeviceByTypeList} from "@/network/device-info";

export default {
  name: "PowerDevice",
  components: { NoData},
  props: {
    label: {
      type: Boolean,
      default: true
    },
    upsHeight: {
      default: '18vh',
    },
    meterHeight: {
      default: '14vh',
    },
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId: {
      handler() {
        this.upsData = null;
        this.meterData = null;
        this.getData();
        this.getDeviceList();
      }
    }
  },
  data() {
    return {
      data: [],
      typeList: ["PM_GGDS"],
      pointCodes: ["m1_a_u ", "m1_b_u ", "m1_c_u", "m1_p", "m2_p"],
      upsData: null,
      meterData: null,
      upsDeviceList: [],
      demDeviceList: []
    }
  },
  mounted() {
    this.getDeviceList();
  },
  methods: {
    getDeviceList() {
      this.upsDeviceList = []
      this.demDeviceList = []
      getDeviceByTypeList(this.typeList,this.spaceId).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_GGDS') {
              this.demDeviceList.push(item)
            }
          })
          if (this.upsDeviceList.length > 0) {
            this.getUpsData(0)
          }
          if (this.demDeviceList.length > 0) {
            this.getDemData(0)
          }
        }
      })
    },
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.typeEngName === 'PM_GGDS') {
              let loadPower = 0;
              item.deviceInfoList.forEach(device => {
                if (device.deviceMeasuringPointHistoryList != null && device.deviceMeasuringPointHistoryList.length > 0) {
                  this.data = []
                  device.deviceMeasuringPointHistoryList.forEach(history => {
                    if (history.pointCode === 'ap' || history.pointCode === 'bp' || history.pointCode === 'cp') {
                      loadPower = loadPower + history.pointValue;
                    }
                    if (history.pointCode === 'mode') {
                      item.mode = history.pointValueName
                    }
                    if (history.pointCode === 'batteryvoltage') {
                      item.voltage = history.pointValueName
                    }
                    if (history.pointCode === 'capacity') {
                      item.capacity = history.pointValueName
                      this.data.push(history.pointValue)
                    }
                  })
                  item.power = loadPower;
                }
              })
              this.upsData = item
            }

            if (item.typeEngName === 'PM_GGDS') {
              this.meterData = item;
            }
          })
        }
      })
    },
    getUpsData(active) {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        deviceId: this.upsDeviceList[active].id,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            let loadPower = 0;
            item.deviceInfoList.forEach(device => {
              if (device.deviceMeasuringPointHistoryList != null && device.deviceMeasuringPointHistoryList.length > 0) {
                this.data = []
                device.deviceMeasuringPointHistoryList.forEach(history => {
                  if (history.pointCode === 'ap' || history.pointCode === 'bp' || history.pointCode === 'cp') {
                    loadPower = loadPower + history.pointValue;
                  }
                  if (history.pointCode === 'mode') {
                    item.mode = history.pointValueName
                  }
                  if (history.pointCode === 'batteryvoltage') {
                    item.voltage = history.pointValueName
                  }
                  if (history.pointCode === 'capacity') {
                    item.capacity = history.pointValueName
                    this.data.push(history.pointValue)
                  }
                })
                item.power = loadPower;
              }
            })
            this.upsData = item
          })
        }
      })
    },
    getDemData(active) {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        deviceId: this.demDeviceList[active].id,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            this.meterData = item;
          })
        }
      })
    },
    skipOverview(deviceInfo) {
      this.$emit('skipOverview', deviceInfo, 'power_category_tag')
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
}

.powerDevice .el-progress >>> .el-progress-bar__outer {
  background-color: rgba(48, 141, 233, .3);
}

.powerDevice .el-progress >>> .el-progress-bar__inner {
  background: linear-gradient(to right, rgba(224, 201, 85, 1), rgba(208, 103, 102, 1));
}

.powerDevice .el-progress >>> .el-progress__text {
  margin-left: 20px;
  color: #FAFAFA;
}
</style>
